import React from 'react';

/**
 * Decorative Nairobi → Arusha → Moshi corridor illustration (inline SVG only).
 * Not interactive — aria-hidden for screen readers.
 */
const SharedTripRouteIllustration = ({ compact = false }) => (
  <svg
    viewBox="0 0 800 220"
    className={`w-full max-w-3xl mx-auto shared-trip-route-illustration${
      compact ? ' shared-trip-route-illustration--compact' : ''
    }`}
    aria-hidden="true"
    focusable="false"
    pointerEvents="none"
    overflow="visible"
  >
    {/* Rear ridge — omitted in compact */}
    {!compact && (
      <path
        d="M 120 130 Q 200 95 300 118 Q 380 128 460 120 L 120 130 Z"
        fill="#4A3C33"
        opacity="0.07"
      />
    )}

    {/* Meru-inspired — sharper peak, left-of-centre */}
    <path
      d="M 220 125 Q 300 52 370 108 Q 400 118 430 122 L 220 125 Z"
      fill="#4A3C33"
      opacity="0.11"
    />

    {/* Kilimanjaro-inspired — broader dome, right-of-centre */}
    <path
      d="M 460 122 Q 540 38 620 95 Q 690 112 760 125 L 460 122 Z"
      fill="#2D1E17"
      opacity="0.09"
    />

    {/* Sun — omitted in compact */}
    {!compact && (
      <circle cx="690" cy="42" r="22" fill="#A44432" opacity="0.16" />
    )}

    {/* Terrain line — stroke only, no filled band under the route */}
    <path
      d="M 40 185 Q 200 175 400 182 Q 600 188 760 178"
      fill="none"
      stroke="#4A3C33"
      strokeWidth="1"
      opacity="0.2"
    />

    {/* Acacia — larger, near Nairobi */}
    <g fill="#2D1E17" opacity="0.31">
      <rect x="108" y="148" width="3" height="22" />
      <ellipse cx="109.5" cy="146" rx="18" ry="9" />
      <ellipse cx="109.5" cy="140" rx="14" ry="7" opacity="0.7" />
    </g>

    {/* Acacia — smaller, near Moshi; omitted in compact */}
    {!compact && (
      <g fill="#2D1E17" opacity="0.25">
        <rect x="668" y="152" width="2.5" height="16" />
        <ellipse cx="669.25" cy="150" rx="12" ry="6.5" />
        <ellipse cx="669.25" cy="145" rx="9" ry="5" opacity="0.7" />
      </g>
    )}

    {/* Route — organic wave in lower third */}
    <path
      d="M 90 168 Q 200 158 290 165 T 400 168 T 510 162 T 710 158"
      fill="none"
      stroke="#2D1E17"
      strokeWidth="2.25"
      strokeDasharray="6 5"
      opacity="0.92"
    />

    {/* City markers ~18%, ~50%, ~82% */}
    <circle cx="144" cy="165" r="6" fill="#A44432" stroke="#FAF3E0" strokeWidth="1.5" />
    <circle cx="400" cy="168" r="6" fill="#A44432" stroke="#FAF3E0" strokeWidth="1.5" />
    <circle cx="656" cy="160" r="6" fill="#A44432" stroke="#FAF3E0" strokeWidth="1.5" />

    {/* Shuttle silhouette between Nairobi and Arusha, heading toward Arusha */}
    <g transform="translate(210, 154)" fill="#2D1E17">
      <rect x="0" y="4" width="28" height="10" rx="2" />
      <rect x="4" y="0" width="20" height="6" rx="2" />
      <circle cx="7" cy="16" r="3" />
      <circle cx="21" cy="16" r="3" />
    </g>

    {/* Serif labels under markers */}
    <text
      x="144"
      y="188"
      textAnchor="middle"
      fill="#2D1E17"
      fontFamily="Georgia, 'Times New Roman', serif"
      fontSize="14"
      fontWeight="700"
    >
      Nairobi
    </text>
    <text
      x="400"
      y="190"
      textAnchor="middle"
      fill="#2D1E17"
      fontFamily="Georgia, 'Times New Roman', serif"
      fontSize="14"
      fontWeight="700"
    >
      Arusha
    </text>
    <text
      x="656"
      y="182"
      textAnchor="middle"
      fill="#2D1E17"
      fontFamily="Georgia, 'Times New Roman', serif"
      fontSize="14"
      fontWeight="700"
    >
      Moshi
    </text>
  </svg>
);

export default SharedTripRouteIllustration;
